// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"T0-z","displaySixCardTiles":"U0-z"};